import {Component} from "@angular/core";
import {Card} from "../../../models/loyalty-card.model";
import {StoreCommonService} from "../../../services/store/store-common.service";
import {LoyaltyCardService} from "../../../services/loyalty/loyalty-card.service";
import {TranslateService} from "@ngx-translate/core";
import {MessageService} from "primeng/api";

@Component({
  selector: 'kv-loyalty-domiciliation-single',
  template: `
    <kv-customer-card-search
      [showBack]="false"
      (onCardSelect)="showDomiciliation($event)"
    ></kv-customer-card-search>
    <p-dialog *ngIf="selectedCard && filteredStoresByChannel && currentStore"
              header="{{ 'card.domiciliation' | translate }}"
              (onHide)="undoDomiciliation()"
              [(visible)]="showDomiciliationModal"
              [modal]="true"
              [draggable]="false"
              [resizable]="false">
      <kv-card-domiciliation
        [card]="selectedCard"
        [filteredStores]="filteredStoresByChannel"
        [currentStore]="currentStore"
        (onCancel)="undoDomiciliation()"
        (onSave)="performDomiciliation($event)"
      ></kv-card-domiciliation>
    </p-dialog>
  `
})
export class LoyaltyDomiciliationSingleComponent {
  selectedCard: Card = null;
  filteredStoresByChannel = null;
  currentStore = null;
  showDomiciliationModal=false;

  constructor(
    private svcStores: StoreCommonService,
    private svcCard: LoyaltyCardService,
    private translate: TranslateService,
    private notification: MessageService
  ) {

  }

  showDomiciliation(card) {
    this.showDomiciliationModal = true;
    this.selectedCard = card;
    console.log(card)
    this.svcStores.getListFilteredByChannel(parseInt(this.selectedCard.channel_id)).subscribe(stores => {
      this.filteredStoresByChannel = stores
    })

    this.svcStores.get(parseInt(this.selectedCard.store_id)).subscribe(currentStore => {
      this.currentStore = currentStore
    })
  }

  undoDomiciliation() {
    this.showDomiciliationModal = false;
    this.selectedCard = null;
  }

  performDomiciliation(store_id) {
    this.svcCard.domiciliate({
      card_id: parseInt(this.selectedCard.id),
      store_from: parseInt(this.selectedCard.store_id),
      store_to: store_id
    }).subscribe(res => {
      this.showDomiciliationModal = false;
      this.translate.get(['card.domiciliation_ok']).subscribe(t => {
        this.notification.add({
          severity: 'success',
          detail: t['card.domiciliation_ok']
        })
      })
    })

  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-single.component.ts